import { render, staticRenderFns } from "./AutoPartUnsalableStat.vue?vue&type=template&id=c7667bae&scoped=true&"
import script from "./AutoPartUnsalableStat.vue?vue&type=script&lang=js&"
export * from "./AutoPartUnsalableStat.vue?vue&type=script&lang=js&"
import style0 from "./AutoPartUnsalableStat.vue?vue&type=style&index=0&id=c7667bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7667bae",
  null
  
)

component.options.__file = "AutoPartUnsalableStat.vue"
export default component.exports